import {Dropdown, IDropdownOption, IDropdownStyles} from '@fluentui/react';
import React from "react";


const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 70 }
};
const options: IDropdownOption[] = [
    { key: 'yes', text: 'Yes' },
    { key: 'no', text: 'No' }
];

class SensitivePersonalData extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {editable: true}
    }

    onChange(e,v)
    {
        this.props.onUpdate('sensitiveGdpr', v.key==='yes');
    }


    render() {
        const def = this.props.sensitiveGdpr? 'yes' : 'no'
        return (
            <div style={{width:'100%', position:'relative'}}>
                    <span>Sensitive Personal Data: </span>
                <div className="dropdown">
                <Dropdown
                    onChange={this.onChange.bind(this)}
                    disabled={this.props.disabled || this.props.isreadonly}
                    selectedKey={def}
                    options={options}
                    styles={dropdownStyles}
                />
                </div>
            </div>
        );
    }
}
export default SensitivePersonalData;





// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/SensitivePersonalData.js